function htmlImgTagToMarkdown(tag: string): string | null {
  const srcMatch = tag.match(/\bsrc=["']([^"']+)["']/i);
  if (!srcMatch) {
    return null;
  }

  const altMatch = tag.match(/\balt=["']([^"']*)["']/i);
  return `\n\n![${altMatch?.[1] ?? ''}](${srcMatch[1]})\n\n`;
}

/**
 * Normalizes CMS/Loom markdown so react-markdown renders headings, lists, and images reliably.
 */
export function normalizeHelpArticleMarkdown(markdown: string): string {
  let normalized = markdown.replace(/<img\b[^>]*?\/?>/gi, (tag) => htmlImgTagToMarkdown(tag) ?? tag);

  normalized = normalized.replace(/<br\s*\/?>/gi, '\n');

  // Loom-style section headers: "1. Title [0:00]" on their own line.
  normalized = normalized.replace(
    /^(\d+\.\s+[^\n]+(?:\[[^\]]+\])?)\s*$/gm,
    (_, title: string) => `\n\n## ${title.trim()}\n\n`,
  );

  return normalized.replace(/\n{3,}/g, '\n\n').trim();
}
